var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({staticClass:"btn btn-primary",class:{ 'w-full': _vm.block },attrs:{"type":_vm.type,"disabled":_vm.disabled}},_vm.$listeners),[_c('span',{staticClass:"z-1 relative flex items-center justify-center"},[(!!_vm.$slots.default)?[_vm._t("default")]:[_vm._v(_vm._s(_vm.label))]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }